import React from 'react'
import TextField from '../../../core/common/textFields/TextField'
import { svgIcons } from '../../../style/fonts/SvgIcons'
import { InputMask } from '@react-input/mask'

const DetailsTab = ({ isReadOnly,formik }: any) => {

    return (
        <div className="row">
            <div className="col-md-4">
                <div className="card h-100">
                    <div className="card-body p-3">
                        <h5>
                            Company Profile
                        </h5>
                        <div className="col-md-12">
                            <TextField
                                label="Industry"
                                type="text"
                                {...formik.getFieldProps("industry")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="SIC Code"
                                type="text"
                                {...formik.getFieldProps("sicCode")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Ticker Symbol"
                                type="text"
                                {...formik.getFieldProps("tickedSymbol")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Ownership"
                                type="text"
                                {...formik.getFieldProps("ownerShip")}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className='card'>
                    <div className='card-body'>
                        <h5 className='mb-2'>
                            Marketing
                        </h5>
                        <div className="col-md-12">
                            <TextField
                                label="Last Campaign Date"
                                type="text"
                                {...formik.getFieldProps("lastCampaignDate")}
                                disabled={isReadOnly}
                                icon={svgIcons.LockIcon}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Marketing Materials"
                                type="text"
                                {...formik.getFieldProps("marketingMaterials")}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <div className='card-body'>
                        <h5 className='mb-2'>
                            Contact Preferences
                        </h5>
                        <div className="col-md-12">
                            <TextField
                                label="Contact Method"
                                type="text"
                                {...formik.getFieldProps("contactMethod")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Email"
                                type="text"
                                {...formik.getFieldProps("email")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Follow Email"
                                type="text"
                                {...formik.getFieldProps("followEmail")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Bulk Email"
                                type="text"
                                {...formik.getFieldProps("bulkEmail")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <div className="form-wrap">
                                <label className='input-label'>
                                    Phone
                                </label>
                                <InputMask mask="+1(___)___-____"
                                    replacement={{ _: /\d/ }}
                                    className='form-control' />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Fax"
                                type="text"
                                {...formik.getFieldProps("fax")}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className='card'>
                    <div className='card-body'>
                        <h5 className='mb-2'>
                            Billing
                        </h5>
                        <div className="col-md-12">
                            <TextField
                                label="Currency"
                                type="text"
                                {...formik.getFieldProps("currency")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Credit Unit"
                                type="text"
                                {...formik.getFieldProps("creditUnit")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Credit Hold"
                                type="text"
                                {...formik.getFieldProps("creditHolder")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Payment Terms"
                                type="text"
                                {...formik.getFieldProps("paymentTerms")}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <div className='card-body'>
                        <h5 className='mb-2'>
                            Shipping
                        </h5>
                        <div className="col-md-12">
                            <TextField
                                label="Shipping Method"
                                type="text"
                                {...formik.getFieldProps("shippingMethod")}
                                disabled={isReadOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                label="Freight Terms"
                                type="text"
                                {...formik.getFieldProps("freightTerms")}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>)
}

export default DetailsTab